module.exports = __webpack_public_path__ + "img/redgold@2x.754b4bb.webp";